export default __webpack_public_path__ + "static/photo-invoice-foster-fam-739666bbf7c6946f89020cbc2ec444e7.jpg";